import {
  ConfinusUI__Forms__CheckboxControllerIdentifier,
  ConfinusUI__Tables__DataTableCellControllerIdentifier,
} from "controllers/identifiers";
import BaseController from "confinus_ui/base_controller";
import CheckboxController from "confinus_ui/forms/checkbox_controller";
import DataTableCellController from "confinus_ui/tables/data_table_cell_controller";

export default class DataTableRowController extends BaseController {
  public static targets = ["checkbox"];

  public static values = {
    href: { type: String, default: null },
    id: { type: String, default: null },
  };

  declare private readonly hrefValue?: string;
  declare private readonly idValue: string;
  declare public readonly checkboxTarget: HTMLInputElement;

  public static classes = ["selected"];
  declare protected readonly selectedClasses: string[];

  public static outlets = [
    ConfinusUI__Tables__DataTableCellControllerIdentifier,
    ConfinusUI__Forms__CheckboxControllerIdentifier,
  ];
  declare private readonly confinusUiTablesDataTableCellOutlets: DataTableCellController[];
  private get cellControllers() {
    return this.confinusUiTablesDataTableCellOutlets;
  }
  declare private readonly confinusUiFormsCheckboxOutlet: CheckboxController;
  private get checkboxController() {
    return this.confinusUiFormsCheckboxOutlet;
  }

  public get id(): string {
    return this.idValue;
  }

  public get disabled() {
    return this.element.classList.contains("opacity-50");
  }

  public set disabled(disabled: boolean) {
    if (disabled) {
      this.element.classList.add("opacity-50");
    } else {
      this.element.classList.remove("opacity-50");
    }
  }

  public rowSelected() {
    this.toggleTargetElementClasses(
      this.element,
      this.checked,
      [],
      this.selectedClasses,
    );
    // Dispatch custom event to notify table controller of selection change
    this.element.dispatchEvent(
      new CustomEvent("data-table-row-selection-changed", {
        bubbles: true,
        detail: {
          id: this.id,
          checked: this.checked,
          checkboxValue: this.checkboxValue,
        },
      }),
    );
  }

  public get checked() {
    if (this.checkboxController) {
      return this.checkboxController.checked;
    }
    return false;
  }

  public set checked(state: boolean) {
    if (this.checkboxController && !this.checkboxController.disabled) {
      this.checkboxController.checked = state;
      this.rowSelected();
    }
  }

  public get checkboxValue(): string {
    if (this.checkboxController) {
      return this.checkboxController.value;
    }
    return "";
  }

  public handleRowClick(e: MouseEvent) {
    const target = e.target;
    if (target) {
      const row = this.element;
      let child = target as HTMLElement | null;
      while (child && child !== row) {
        const cell = this.cellControllers.find((c) => c.element === child);
        if (cell && cell.data.get("no-path-navigation")) {
          return;
        }
        child = child.parentElement;
      }
    }
    const href = this.hrefValue;
    if (href) {
      window.location.href = href;
    }
  }
}
